import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import StoryblokHelperPlugin from './services/storyblok'
import InLineSvg from 'vue-inline-svg'
import VueMeta from 'vue-meta'

import './scss/app.scss'

Vue.use(StoryblokHelperPlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueMeta)

Vue.config.productionTip = false
Vue.config.devtools      = true

Vue.component('inline-svg', InLineSvg)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
